exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* make the placeholder black so it matches other selects */\n.vue-treeselect__placeholder[data-v-c526bb7c] {\n  color: black;\n}\n.vue-treeselect--focused .vue-treeselect__placeholder[data-v-c526bb7c] {\n  color: #BDBDBD;\n}\n", ""]);

// exports
